export default "__VITE_ASSET__CLB$Ld86__"